export const KHARON_V2_COLUMBIA_COMPANY_ID = 'JSVVB8E9M4G';

export const KHARON_V2_ALLOWED_USER_IDS: ReadonlySet<string> = new Set([
  '6XCY8N2V6DP',
  '2DYWTFQNNTB',
  'QNDVRJR18RR',
]);

export const ENTITY_SCREENING_ENTITY_TYPE = {
  KHARON: 'KHARON',
  UFLPA: 'UFLPA',
} as const;

export const ENTITY_SCREENING_FEATURE_ID = {
  KHARON: 'kharon-v2',
  UFLPA: 'entity-screening-v2',
} as const;

export type EntityScreeningEntityType =
  (typeof ENTITY_SCREENING_ENTITY_TYPE)[keyof typeof ENTITY_SCREENING_ENTITY_TYPE];

/**
 * The one embedding model every screening embedding is written with. Several
 * db/service files still carry their own private `MODEL` literal; new code
 * uses this constant.
 */
export const ENTITY_SCREENING_EMBEDDING_MODEL = 'text-embedding-3-large';

export const ENTITY_SCREENING_MATCHING_PROCESS_TYPE = {
  LIST: 'LIST',
  COMPANIES: 'COMPANIES',
} as const;

export type EntityScreeningMatchingProcessType =
  (typeof ENTITY_SCREENING_MATCHING_PROCESS_TYPE)[keyof typeof ENTITY_SCREENING_MATCHING_PROCESS_TYPE];

export const ENTITY_SCREENING_VALIDATION_STATUS = {
  REVALIDATION: 'REVALIDATION',
  FLAGGED: 'FLAGGED',
  DISMISSED: 'DISMISSED',
} as const;

export type EntityScreeningValidationStatus =
  (typeof ENTITY_SCREENING_VALIDATION_STATUS)[keyof typeof ENTITY_SCREENING_VALIDATION_STATUS];

export const ENTITY_SCREENING_REVALIDATION_REASON = {
  KHARON_ENTITY_CHANGE: 'KHARON_ENTITY_CHANGE',
  /**
   * A UFLPA entity's embedded name/aliases changed. UFLPA has no change audit
   * table (and the platform adds no new history tables), so a flip with this
   * reason carries no `revalidation_change_id`.
   */
  UFLPA_ENTITY_CHANGE: 'UFLPA_ENTITY_CHANGE',
  COMPANY_NAME_CHANGE: 'COMPANY_NAME_CHANGE',
} as const;

export type EntityScreeningRevalidationReason =
  (typeof ENTITY_SCREENING_REVALIDATION_REASON)[keyof typeof ENTITY_SCREENING_REVALIDATION_REASON];
